module.exports = __webpack_public_path__ + "static/media/ProfileHeaderLogoFullIcon.676482a0.svg";